export const STUDIO_PLUS_PRODUCT_TYPE = {
  PRO: 'PRO',
  PLUS: 'PLUS',
} as const

export type StudioPlusProductType = (typeof STUDIO_PLUS_PRODUCT_TYPE)[keyof typeof STUDIO_PLUS_PRODUCT_TYPE]

export const STUDIO_PLUS_BILLING_TERM = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const

export type StudioPlusBillingTerm = (typeof STUDIO_PLUS_BILLING_TERM)[keyof typeof STUDIO_PLUS_BILLING_TERM]
